module.exports = __webpack_public_path__ + "943d854982981b513393ce09b523a263.pdf";